<a *ngIf="isLoggedIn(); else notLoggedIn" href="javascript: void(0);" (click)="openModal()" [ga]="['Price Alert', 'Open', location]">
  <ng-container *ngTemplateOutlet="data?.active ? (activeStateTemplate ? activeStateTemplate : defultActiveStateTemplate) : (inactiveStateTemplate ? inactiveStateTemplate : defultInactiveStateTemplate)"></ng-container>
</a>

<modal *ngIf="showModal" [show]="showModal" [x]="false" (onClose)="closeModal()" [size]="'md'">
  <price-alert [pair]="pair" [useGlobalCurrency]="useGlobalCurrency" [priceAlert]="data" (close)="closeModal()" (save)="onSave()"></price-alert>
</modal>

<ng-template #notLoggedIn>
  <a class="bell" routerLink="/login" [ga]="['Price Alert', 'Login', location]">
    <ng-container *ngTemplateOutlet="inactiveStateTemplate ? inactiveStateTemplate : defultInactiveStateTemplate"></ng-container>
  </a>
</ng-template>

<ng-template #defultInactiveStateTemplate>
  <img src="assets/images/icons/bell-inactive.svg" alt="Price Alert" class="icon-lg">
</ng-template>

<ng-template #defultActiveStateTemplate>
  <img src="assets/images/icons/bell-active.svg" alt="Price Alert" class="icon-lg">
</ng-template>
